<template>
  <a-modal
    v-model="visible"
    class="modal"
    :maskClosable ="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
  <div slot="title" class="tip-icon"> {{title}} </div>
    <div class="message">
      <a-form-model ref="ruleForm" :model="content" :rules="rules">
            <a-form-model-item ref="accountName" label="客户姓名" prop="accountName">
                <a-input  v-model="content.accountName" disabled/>
            </a-form-model-item>
            <a-form-model-item ref="accountNo" label="客户编号" prop="accountNo">
                <a-input  v-model="content.accountNo" disabled/>
            </a-form-model-item>
            <a-form-model-item ref="accountNo" label="客户账号" prop="accountNo">
                <a-input  v-model="content.accountNo" disabled/>
            </a-form-model-item>
            <a-form-model-item ref="accountAmount" label="退款金额" prop="accountAmount" >
              <a-input-number placeholder="请输入退款金额" v-model="content.accountAmount" class="input-number-order" :formatter="value => `${value} 元`"/>
              <div style="margin-top: 5px">
                <span>账户余额：{{accountData.accountAmount}} 元</span>
              </div>
            </a-form-model-item>
        </a-form-model>
    </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button type="primary" @click="handleOk" :loading="disabled"
        >确 定</a-button
      >
    </template>
  </a-modal>
</template>

<script>
import {
  accountRefund,
  queryByOpenid
} from "@/api/api.js"
import upload from "@/components/upload/upload.vue";
import { DictionaryService } from '@common/services/dictionary.service'
export default {
  name: "accountRefundModal",
  props: ["visible", "userData", "title", "type"],
  data() {
    var checkAge = (rule, value, callback) => {
      if (value) {
        if (value < 0) {
          return callback(new Error('充值金额不能为负数'));
        }
        if (value > Number(this.accountData.accountAmount)) {
          return callback(new Error('充值金额不能超过账户余额'));
        }
        return callback(); 
      } else {
        return callback();
      }
    };
    return {
      id:'',
      //数据字典
      usrRTList: [],
      usrRSList: [],
      accountData:[],
      //参数
      content: {
        accountAmount: '',
      },
      disabled: false,
      //校验规则
      rules: {
      accountAmount: [
        {
            required: true,
            message: "充值金额不能为空！",
            trigger: "blur",
        },{
            validator: checkAge,
            trigger: "change",
        }
        ],
      },
    };
  },
  created() {
    this.queryByOpenid(this.userData.openid);
  },
  methods: {
    //通过openid查询账户
    queryByOpenid(dataId) {
      queryByOpenid({ openId: dataId }).then(
        (res) => {
          this.accountData = res.content;
          // //单位分转换为元
          this.$set(this.content, "accountName", this.accountData.accountName);
          this.$set(this.content, "accountNo", this.accountData.accountNo);
          this.$set(this.content, "accountAmount", this.accountData.accountAmount);
        },
        (err) => {
          this.$message.error('查询账户失败')
        }
      )
    },
    handleOk(e) {//弹窗确定
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
        this.disabled = true;
        accountRefund({
            accountNo: this.accountData.accountNo,
            openid: this.accountData.openId,
            upRefundAmount:this.content.accountAmount,
        }).then((res) => {
                if (res.code == "0000") {
                    this.disabled = false;
                    this.success("退款成功");
                    this.$emit("close");
                    this.$emit("queryList");
                }
            },
            (err) => {
                  this.disabled = false;
            }
        );
        }
      });
    },
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
      this.$refs["ruleForm"].resetFields();
    },
    success(title) {
      //提示
      this.$message.success(title, 3);
    },
  },
};
</script>

<style lang="less" scoped="scoped">
.message {
  width: 100%;
  height: auto;
  
  .ant-form-item{
    display: flex;
    margin-bottom: 20px !important;
  }
  /deep/ .ant-form-item-label{
    width: 120px;
  }
  /deep/ .ant-form-item-control{
    width: 350px;
  }
  /deep/ .input-number-order{
    width: 350px;
  }
}
</style>